import { Controller } from "@hotwired/stimulus"

// A muted looping video that plays while on screen.
//
// Autoplay is our decision, not the element's: the video starts when it
// scrolls into view, pauses when it leaves, and never starts on its own for
// someone who asked for reduced motion. The button always works either way.
export default class extends Controller {
  static targets = ["video", "control", "playIcon", "pauseIcon"]
  static values = { autoplay: Boolean, playLabel: String, pauseLabel: String }

  connect() {
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.pausedByViewport = false
    this.syncPlaying()

    if (!this.autoplayValue || this.reducedMotion) return

    this.observer = new IntersectionObserver(([entry]) => this.visibilityChanged(entry.isIntersecting))
    this.observer.observe(this.videoTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  visibilityChanged(visible) {
    if (visible) {
      this.videoTarget.play().catch(() => {})
      this.pausedByViewport = false
    } else if (!this.videoTarget.paused) {
      this.pausedByViewport = true
      this.videoTarget.pause()
    }
  }

  toggle() {
    // A deliberate choice overrides the viewport from here on.
    this.observer?.disconnect()
    if (this.videoTarget.paused) {
      this.videoTarget.play().catch(() => {})
    } else {
      this.videoTarget.pause()
    }
  }

  syncPlaying() {
    const playing = !this.videoTarget.paused && !this.videoTarget.ended
    this.playIconTarget.hidden = playing
    this.pauseIconTarget.hidden = !playing
    this.controlTarget.setAttribute("aria-label", playing ? this.pauseLabelValue : this.playLabelValue)
  }
}
